import axios, { AxiosResponse } from 'axios'

import { Response } from '@models/apiBase'
import { NetPromoterScoreItemModel, NetPromoterScoreModel } from '@models/netPromoterScore'

import { API_URL } from '@/constants/constant'
import { ID } from '@models/base'

type ResponseNetPromoterScore = Response<{
  net_promoter_score: NetPromoterScoreModel
}>

type ResponseNetPromoterScoreWithItem = Response<{
  net_promoter_score: NetPromoterScoreModel
  net_promoter_score_item: NetPromoterScoreItemModel
}>

export type PayloadStartNetPromoterScoreBySalesInvoice = {
  sales_invoice_id: ID
}

export type PayloadStartNetPromoterScoreByQueueNumber = {
  queue_number_id: ID
}

export type PayloadUpdateNetPromoterScoreItem = {
  rate: number | null
}

interface INetPromoterScoreAPI {
  startBySalesInvoice: (payload: PayloadStartNetPromoterScoreBySalesInvoice) => Promise<ResponseNetPromoterScore>

  startByQueueNumber: (payload: PayloadStartNetPromoterScoreByQueueNumber) => Promise<ResponseNetPromoterScore>

  endActive: () => Promise<ResponseNetPromoterScore>

  getActive: () => Promise<ResponseNetPromoterScore>

  updateActiveItem: (
    itemId: ID,
    payload: PayloadUpdateNetPromoterScoreItem
  ) => Promise<ResponseNetPromoterScoreWithItem>
}

const NET_PROMOTER_SCORE_URL = `${API_URL}/net-promoter-scores`

const NetPromoterScoreAPI: INetPromoterScoreAPI = {
  startBySalesInvoice: async (payload) => {
    return axios.post(`${NET_PROMOTER_SCORE_URL}/start-by-sales-invoice`, payload).then((r: AxiosResponse) => r.data)
  },

  startByQueueNumber: async (payload) => {
    return axios.post(`${NET_PROMOTER_SCORE_URL}/start-by-queue-number`, payload).then((r: AxiosResponse) => r.data)
  },

  endActive: async () => {
    return axios.patch(`${NET_PROMOTER_SCORE_URL}/active/end`).then((r: AxiosResponse) => r.data)
  },

  getActive: async () => {
    return axios.get(`${NET_PROMOTER_SCORE_URL}/active`).then((r: AxiosResponse) => r.data)
  },

  updateActiveItem: async (itemId, payload) => {
    return axios.patch(`${NET_PROMOTER_SCORE_URL}/active/items/${itemId}`, payload).then((r: AxiosResponse) => r.data)
  },
}

export default NetPromoterScoreAPI
